import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const RowsPerPageCont = styled(BodyRegularS)`
  align-items: center;
  display: flex;
  height: 40px;
  font-size: 14px;
`;

export const PerPageText = styled.span`
  ${({ theme }: IThemeProvider) => `
    margin-right: ${theme.layout.spacing.centy};
  `}
`;

export const PageCont = styled.div`
  display: flex;
  width: fit-content;
  height: 40px;
`;
